import { identity } from 'lodash';

export const dummyFormatter = {
  bright: identity,
  dimmed: identity,
  blue: identity,
  yellow: identity,
  red: identity,
};
